import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { FormField } from '../../../global/form/form-field/form-field';
import { CommonPopupBodyFooterLayout } from '../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../global/sub-window/common/common-close-sub-window-buttons';
import { RoleFormVM } from '../role-form.viewmodel';
import { RolesAction } from '../../../../api/roles.dao';
import OptionsButton from '../../../global/options-button/options-button';
import { ADD_TEXT, APPLY_TEXT, CANCEL_TEXT, DESCRIPTION } from '../../../../constants/common-labels.constants';

interface IProps {
    vm: RoleFormVM;
    intl: IntlShape;
}

const RoleFormPresentation = injectIntl(mobxReact.observer((props: IProps) => {
    const { intl, vm: { roleFormDataVM, linkName, isSaving, isLoading, handleSubmit, onDeleteRole } } = props;
    const isEdit = !!linkName;

    const roleOptions = [
        isEdit && {
            label: 'Delete Role',
            action: onDeleteRole,
            danger: true
        }
    ].filter(Boolean);


    const formSubmitHandler = () => {
        const defineFormType = isEdit ? RolesAction.Edit : RolesAction.Create;
        return handleSubmit(intl, defineFormType);
    };

    if (isLoading) {
        return <CommonPopupBodyFooterLayout
            body={
                <div className='oe-form meeting-form'>
                    <FormattedMessage
                        description='Label text'
                        defaultMessage='Loading role data{suffix}'
                        id='oe.role.loadingData'
                        values={{
                            suffix: '...'
                        }}
                    />
                </div>
            }
        />;
    }

    return (
        <CommonPopupBodyFooterLayout
            body={
                <div>
                    <div className='oe-form'>
                        {<div className='oe-form__body'>
                            <FormField
                                label={intl.formatMessage(
                                    {
                                        id: 'oe.role.name',
                                        description: 'Role name title',
                                        defaultMessage: 'Name',
                                    })
                                }>
                                <input
                                    type='text'
                                    className='oe-form-field__control'
                                    value={roleFormDataVM.name}
                                    onChange={({ target: { value } }) => roleFormDataVM.setName(value)}
                                />
                                {roleFormDataVM.showValidationErrors() ? <div className='oe-form-field__error'>{roleFormDataVM.getNameError(intl)}</div> : null}
                            </FormField>
                            <FormField
                                label={intl.formatMessage(DESCRIPTION)
                                }>
                                <textarea
                                    className='oe-form-field__control'
                                    value={roleFormDataVM.description}
                                    onChange={({ target: { value } }) => roleFormDataVM.setDescription(value)}
                                />
                                {roleFormDataVM.showValidationErrors()
                                    ? <div className='oe-form-field__error'>{roleFormDataVM.getDescriptionError(intl)}</div> : null}
                            </FormField>
                            {roleFormDataVM.serverErrorMessage && <div className='oe-form-field__error'>{roleFormDataVM.serverErrorMessage}</div>}
                        </div>
                        }
                    </div>
                </div>
            }
            footer={
                <>
                    {isSaving &&
                    <span className='oe-popup-layout__footer-status-area'>
                            {intl.formatMessage({
                                id: 'oe.role.roleIsBeingSaved',
                                description: 'Placeholder about saving role',
                                defaultMessage: 'Role is being saved, please wait...',
                            })}
                        </span>
                    }

                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(isEdit ? APPLY_TEXT : ADD_TEXT)}
                            modifier={['fat', 'confirm-safe']}
                            onClick={formSubmitHandler}
                            disabled={isSaving}
                        />
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(CANCEL_TEXT)}
                        />
                        {!!roleOptions.length && <OptionsButton
                            className='options-button--right-margin-auto'
                            modifier={['fat', 'options']}
                            label='More...'
                            options={roleOptions}
                            position='top'
                            align='start'
                        />}
                    </div>
                </>
            }
        />
    );

}));

export { RoleFormPresentation };
